import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({selected}) => (
  // switching svg sprite fragments dynamically is not working in Safari so use this workaround
  // except this case I expect using svg sprite in this project to reduce HTTP requests
  <img
    className="checkbox small-margin-right"
    src={`${window.NationalInstruments.bentoBox.rootUrl}/images/${
      selected ? 'checkbox-checked.svg' : 'checkbox-unchecked.svg'
    }`}
  />
);

Checkbox.propTypes = {
  selected: PropTypes.bool.isRequired,
};

Checkbox.defaultProps = {
  selected: false,
};

export default Checkbox;
